import React from 'react';
import {
  CContainer,
  CListGroup,
  CListGroupItem,
  CCard,
  CCardBody,
  CCardText,
  CFormSelect,
} from '@coreui/react-pro';
import {
  Map,
  useMap,
  MapControl,
  ControlPosition,
} from '@vis.gl/react-google-maps';
import MapLoadingSpinner from '../shared/MapLoadingSpinner';
import MyFieldsMarker from './MyFieldsMarker';
import MyFieldsWeightedAverageCircle from './MyFieldsWeightedAverageCircle';
import MyFieldsAgvanceFieldBoundary from './MyFieldsAgvanceFieldBoundary';
//import _ from 'lodash';
import {
  initMyFieldsInterface,
  userSelectedCropYear,
  userSelectedCommodity,
  userSelectedMappedFarmField,
  //fetchDigiFarmFields,
} from './mapping-actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const MyFields = () => {

  const dispatch = useDispatch();

  const map = useMap();

  const {
    sidebarVisible,
    sidebarUnfoldable,
  } = useSelector(state => state.userSettings);

  const {
    fetchingFarmFields,
    selectedCropYear,
    selectedCommodity,
    cropYearsDropDownListDataSource,
    commoditiesDropDownListDataSource,
    mappedFarmFields,
    nonHarvestedMappedFarmFields,
    //mappedDigiFarmFields,
    selectedMappedFarmField,
  } = useSelector(state => state.mapping);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    dispatch(initMyFieldsInterface());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  /*
  React.useEffect(() => {
    if (map !== null) {
      map.data.setStyle(setStyles);
    }
  }, [map]);

  React.useEffect(() => {
    if (map !== null) {
      map.data.forEach((feature) => {
        map.data.remove(feature);
      });
      mappedDigiFarmFields.forEach((farmField) => {
        map.data.addGeoJson(farmField);
      });
    }
  }, [mappedDigiFarmFields, map]);

  const onBoundsChanged = _.debounce((bounds) => {
    const ne = bounds.map.getBounds().getNorthEast();
    const sw = bounds.map.getBounds().getSouthWest();
    if (bounds.detail.zoom >= 14) {
      dispatch(fetchDigiFarmFields(sw.lng(), sw.lat(), ne.lng(), ne.lat(), true));
    }
    else if (bounds.detail.zoom < 14) {
     bounds.map.data.forEach((feature) => {
      bounds.map.data.remove(feature);
     });
    }
  }, 2000);

  const setStyles = (feature) => {
    return {fillColor: 'green',};
  }
  */

  React.useEffect(() => {
    if (selectedMappedFarmField !== null) {
      zoomToLocation(selectedMappedFarmField.Latitude, selectedMappedFarmField.Longitude);
    }
  }, [selectedMappedFarmField]); // eslint-disable-line react-hooks/exhaustive-deps

  const zoomToLocation = (latitude, longitude) => {
    map.panTo({
      lat: latitude,
      lng: longitude,
    });
    if (map.zoom >= 12) {
      return;
    }
    else {
      var zoomStep = map.zoom;
      const interval = setInterval(() => {
        if (zoomStep === 12) {
          clearInterval(interval);
        }
        map.setZoom(zoomStep++);
      }, 200);
    }
  }

  const height = windowHeight - 64;

  var width = windowWidth;

  if (sidebarUnfoldable === true && sidebarVisible === true) {
    width -= 64;
  }
  else if (sidebarUnfoldable === false && sidebarVisible === true) {
    width -= 256;
  }

  return (    
    <div style={{flexDirection: 'row', display: 'flex',}}>
      <div style={{
        width: 300,
        height: height,
        overflowY: 'auto', 
      }}>
        <CContainer fluid>
          <CCard>
            <CCardBody>
              <CFormSelect
                floatingLabel='Select Crop Year'
                className='mb-3'
                style={{width: '100%', lineHeight: 4,}}
                value={selectedCropYear}
                options={cropYearsDropDownListDataSource}
                onChange={(e) => dispatch(userSelectedCropYear(e.target.value))} />
              <CFormSelect
                floatingLabel='Select Commodity'
                className='mb-3'
                style={{width: '100%', lineHeight: 4,}}
                value={selectedCommodity}
                options={commoditiesDropDownListDataSource}
                onChange={(e) => dispatch(userSelectedCommodity(e.target.value))} />
              <CCardText>
                Click on a Field Name below to zoom to the field and see its data.
              </CCardText>
              <CListGroup>
                {
                  mappedFarmFields.map((field, index) => {
                    return (
                      <CListGroupItem 
                        key={field.FieldId + index}
                        active={selectedMappedFarmField?.fieldGUID === field.fieldGUID}
                        style={{cursor: 'pointer',}}
                        onClick={() => dispatch(userSelectedMappedFarmField(field))}>
                        {field.FieldId}
                      </CListGroupItem>
                    );
                  })
                }
              </CListGroup>
            </CCardBody>
          </CCard>
          <div style={{height: '20px'}} />
          <CCard>
            <CCardBody>
              <CCardText style={{
                fontFamily: 'Montserrat-Bold',
                fontWeight: 'bolder',
              }}>
                The Fields below contain no harvest data for the selected crop year or commodity.
              </CCardText>
              <CListGroup>
                {
                  nonHarvestedMappedFarmFields.map((field, index) => {
                    return (
                      <CListGroupItem 
                        key={field.FieldId + index}
                        active={selectedMappedFarmField?.fieldGUID === field.fieldGUID}
                        style={{cursor: 'pointer',}}
                        onClick={() => dispatch(userSelectedMappedFarmField(field))}>
                        {field.FieldId}
                      </CListGroupItem>
                    );
                  })
                }
              </CListGroup>
            </CCardBody>
          </CCard>
        </CContainer>
      </div>
      <div style={{flexDirection: 'column', display: 'flex',}}>
        <div
          style={{
            width: width - 300,
            height: height,
          }}>
          <Map
            mapId='MY_FIELDS'
            defaultCenter={{
              lng: -88.257311,
              lat: 40.112519,
            }} 
            defaultZoom={parseInt(process.env.REACT_APP_DEFAULT_MAP_ZOOM)}
            fullscreenControl={false}
            mapTypeControl={true}
            streetViewControl={false}
            mapTypeId='hybrid'
            //onBoundsChanged={(bounds) => onBoundsChanged(bounds)}
          >
            {
              fetchingFarmFields === true ? (
                <MapControl position={ControlPosition.CENTER}>
                  <MapLoadingSpinner loadingText='Fetching Farm Fields' />
                </MapControl>
              ) : null
            }
            {
              selectedMappedFarmField !== null ? (
                <>
                  <MyFieldsMarker farmField={selectedMappedFarmField} />
                </>
              ) : null
            }
            <MyFieldsWeightedAverageCircle farmField={selectedMappedFarmField} />
            {
              selectedMappedFarmField?.GoogleMapFieldPolygons.map((polygon, index) => (
                <MyFieldsAgvanceFieldBoundary farmFieldPolygon={polygon} key={index} />
              ))
            }
          </Map>
        </div>
      </div>
    </div>
  );
}

export default MyFields;
